import { useContext, useEffect, useState } from "react";
import LineFontConfig from "../VideoConfig/VoiceConfig/LineFontConfig/LineFontConfig";
import VoiceConfig from "../VideoConfig/VoiceConfig/VoiceConfig";
import VoiceLine from "../VideoConfig/VoiceLine/VoiceLine";
import { mixCutDetailContext } from "../MixCutDetail";
import { convertKeysToSnakeCase } from "@/utils/tool";
import useVideoGroup from "@/useStore/mixCutDetail/useVideoGroup";
import useCaption from "@/useStore/mixCutDetail/useCaption";
import { observer } from "mobx-react";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import usePreviewConfig from "@/useStore/preview/usePreview";
import { toJS } from "mobx";
import { Message } from "@arco-design/web-react";
import {checkLanguage} from "@/utils/judgment";
const CaptionConfig = observer((props) => {
  const { sensitiveData } = props;
  const { projectCaption } = useVideoGroup();
  const {
    handleProjectCaptionToIndexChange,
    handleProjectCaptionItemAddItem,
    hanldeProjectCaptionItemDeleteItem,
  } = useCaption();
  const { handlePreviewCaptionChange, handleClipIdChange } = usePreviewConfig();
  const { global } = useMixCutDetail();
  const { videoGroupActive } = useContext(mixCutDetailContext);
  const [captionEditorIndex, setCaptionEditorIndex] = useState(0);
  const [selector, setSelector] = useState(1);
  useEffect(() => {
    handlePreviewCaptionChange(
      ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex] ||
        null,
    );
    handleClipIdChange(null);
  }, [captionEditorIndex]);

  useEffect(() => {
    console.log(videoGroupActive, JSON.stringify(projectCaption), '拖拽后')
    setCaptionEditorIndex(0);
  }, [videoGroupActive]);
  return (
    <>
      <VoiceLine
        selector={selector}
        sensitiveData={sensitiveData}
        captionEditorIndex={captionEditorIndex}
        onCaptionEditorIndexChange={(e) => {
          setCaptionEditorIndex(e);
        }}
        handleAddButtonClick={() => {
          handleProjectCaptionItemAddItem(videoGroupActive);
        }}
        handleDeleteButtonClick={(index) => {
          hanldeProjectCaptionItemDeleteItem(videoGroupActive, index);
        }}
        onChange={(e, str: any, playContent) => {
          const newProjectCaptionItem = {
            ...projectCaption[videoGroupActive][captionEditorIndex],
          };
          newProjectCaptionItem.content = e;
          newProjectCaptionItem._content_json = str;
          newProjectCaptionItem._preview = playContent;
          handleProjectCaptionToIndexChange(
            videoGroupActive,
            captionEditorIndex,
            newProjectCaptionItem,
          );
        }}
        value={((projectCaption || [])[videoGroupActive] || []).map(
          (item) => item?._content_json,
        )}
        style={{ marginTop: 13 }}
      />
      <VoiceConfig
        emitTimbreSelector={(e) => {
          setSelector(e)
        }}
        handleGlobalCaptionChange={(e) => {
          if (projectCaption?.length > 0) {
            const newProjectCaptionItem = {
              ...(projectCaption || [])[videoGroupActive][captionEditorIndex],
            };
            newProjectCaptionItem.voice_setting.is_global = e;
            handleProjectCaptionToIndexChange(
              videoGroupActive,
              captionEditorIndex,
              newProjectCaptionItem,
            );
          }
        }}
        global={global}
        is_global={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.voice_setting?.is_global
        }
        style={{ marginTop: 13 }}
        speedValue={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.voice_setting?.speed_ratio
        }
        pitchValue={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.voice_setting?.pitch_ratio
        }
        speekerId={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.voice_setting?.speaker_id
        }
        volume={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.voice_setting?.volume_ratio
        }
        handleSpeedValueChange={(e) => {
          if (projectCaption?.length > 0) {
            const newProjectCaptionItem = {
              ...(projectCaption || [])[videoGroupActive],
            }[captionEditorIndex];
            newProjectCaptionItem.voice_setting.speed_ratio = e;
            handleProjectCaptionToIndexChange(
              videoGroupActive,
              captionEditorIndex,
              newProjectCaptionItem,
            );
          }
        }}
        handlePitchValueChange={(e) => {
          if (projectCaption?.length > 0) {
            const newProjectCaptionItem = {
              ...(projectCaption || [])[videoGroupActive],
            }[captionEditorIndex];
            newProjectCaptionItem.voice_setting.pitch_ratio = e;
            handleProjectCaptionToIndexChange(
              videoGroupActive,
              captionEditorIndex,
              newProjectCaptionItem,
            );
          }
        }}
        handleSpeekerIdChange={(e, name, rate, platform, lang, gender, type ) => {
          if (
            projectCaption &&
            (projectCaption[videoGroupActive] || [])[captionEditorIndex]
          ) {
            const str = projectCaption[videoGroupActive][captionEditorIndex].content.map(item => item.replace(/<\/?speak>/g, '')).join('')
            if (str && !checkLanguage(lang, str) && selector !== 6) {
              Message.error('请选择与台词语言一致的配音选项');
              return;
            }
            const newProjectCaptionItem = {
              ...(projectCaption || [])[videoGroupActive],
            }[captionEditorIndex];
            newProjectCaptionItem.voice_setting.speaker_id = e;
            newProjectCaptionItem.voice_setting.speaker_name = name;
            newProjectCaptionItem.voice_setting.default_speed_rate = rate;
            newProjectCaptionItem.voice_setting.platform = platform;
            newProjectCaptionItem.voice_setting.lang = lang;
            newProjectCaptionItem.voice_setting.gender = gender;
            newProjectCaptionItem.voice_setting.type = type;
            handleProjectCaptionToIndexChange(
              videoGroupActive,
              captionEditorIndex,
              newProjectCaptionItem,
            );
          }
        }}
        handleVolumeChange={(e) => {
          if (projectCaption?.length > 0) {
            const newProjectCaptionItem = {
              ...(projectCaption || [])[videoGroupActive],
            }[captionEditorIndex];
            newProjectCaptionItem.voice_setting.volume_ratio = e;
            handleProjectCaptionToIndexChange(
              videoGroupActive,
              captionEditorIndex,
              newProjectCaptionItem,
            );
          }
        }}
      />
      <LineFontConfig
        data={
          ((projectCaption || [])[videoGroupActive] || [])[captionEditorIndex]
            ?.text_setting
        }
        global={global}
        style={{ marginTop: 13 }}
        handleTextSettingChange={(e) => {
          const newProjectCaptionItem = {
            ...projectCaption[videoGroupActive],
          }[captionEditorIndex];
          newProjectCaptionItem.text_setting = convertKeysToSnakeCase(e);
          switch (e.alignment) {
            case "left":
              newProjectCaptionItem.text_setting.x = 0;
              break;
            case "center":
              newProjectCaptionItem.text_setting.x = 0.5;
              break;
            case "right":
              newProjectCaptionItem.text_setting.x = 1;
              break;
          }
          handleProjectCaptionToIndexChange(
            videoGroupActive,
            captionEditorIndex,
            newProjectCaptionItem,
          );
        }}
      />
    </>
  );
});

export default CaptionConfig;
